import axios from 'axios';
import { ChangeEvent, FormEvent, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import navigateBackBlackIcon from '../assets/svg/navigate-back-black.svg';
import navigateBackWhiteIcon from '../assets/svg/navigate-back-white.svg';
import ModalComponent from '../components/modal';
import CategoryPill from '../components/category-pill';
import { categories } from '../utils/category-colors';
import MDEditor from '@uiw/react-md-editor';
import style from '../assets/markdown.styles.module.css';
import React from 'react';
import { jwtDecode } from 'jwt-decode';



const authUsers = [
  'vabatista@gmail.com',
  'gabi.estrella@yahoo.com'
]

type FormData = {
  title: string;
  authorName: string;
  imageLink: string;
  categories: string[];
  description: {
    'pt-br': string;
    'en': string;
  };
  isFeaturedPost: boolean;
};
function AddBlog() {
  const [selectedImage, setSelectedImage] = useState<string>('');
  const [loggedUser, setLoggedUser] = useState('');
  const [activeTab, setActiveTab] = useState<'pt-br' | 'en'>('pt-br');
  const [isTranslating, setIsTranslating] = useState(false);

  useEffect(() => {
    const gtoken = localStorage.getItem('g-token');
    if (gtoken !== null) {
      const decoded: { email: string } = jwtDecode(gtoken as string);
      if (authUsers.includes(decoded.email)) {
        setLoggedUser(decoded.email);
      }
    }
  }, []);
  
  
  const handleImageSelect = (imageUrl: string) => {
    setSelectedImage(imageUrl);
  };

  const [modal, setmodal] = useState(false);
  const [formData, setFormData] = useState<FormData>({
    title: '',
    authorName: '',
    imageLink: '',
    categories: [],
    description: {
      'pt-br': '',
      'en': '',
    },
    isFeaturedPost: false,
  });

  const handleTranslateContent = async () => {
    const textToTranslate = formData.description['pt-br'];
    if (!textToTranslate) {
      toast.error('Digite o conteúdo em português primeiro.');
      return;
    }
    
    setIsTranslating(true);
    try {
      const response = await axios.post(
        (process.env.REACT_APP_API_PATH || '') + '/api/posts/translate',
        { text: textToTranslate }
      );
      if (response.data && response.data.translation) {
        setFormData({
          ...formData,
          description: {
            ...formData.description,
            'en': response.data.translation
          }
        });
        toast.success('Tradução gerada com sucesso!');
      }
    } catch (err: any) {
      toast.error('Erro na tradução: ' + err.message);
    } finally {
      setIsTranslating(false);
    }
  };

  //checks the length of the categories array and if the category is already selected
  const isValidCategory = (category: string): boolean => {
    return formData.categories.length >= 3 && !formData.categories.includes(category);
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleEditorChange = (value: any) => {
    setFormData({
      ...formData,
      description: {
        ...formData.description,
        [activeTab]: value || '',
      }
    });
  };

  const handleCategoryClick = (category: string) => {
    if (isValidCategory(category)) return;

    if (formData.categories.includes(category)) {
      setFormData({
        ...formData,
        categories: formData.categories.filter((cat) => cat !== category),
      });
    } else {
      setFormData({
        ...formData,
        categories: [...formData.categories, category],
      });
    }
  };

  const handleselector = () => {
    setFormData({
      ...formData,
      imageLink: selectedImage,
    });
    setmodal(false);
  };
  const handleCheckboxChange = () => {
    setFormData({ ...formData, isFeaturedPost: !formData.isFeaturedPost });
  };
  
  const validateFormData = () => {
    if (
      !formData.title ||
      !formData.authorName ||
      !formData.imageLink ||
      !formData.description['pt-br'] ||
      formData.categories.length === 0
    ) {
      toast.error('All fields must be filled out.');
      return false;
    }
    const imageLinkRegex = /\.(jpg|jpeg|png|webp)$/i;
    if (!imageLinkRegex.test(formData.imageLink)) {
      toast.error('Link da imagem deve ser com extensão .jpg, .jpeg, .webp ou .png');
      return false;
    }
    if (formData.categories.length > 3) {
      toast.error('Selecione até 3 categorias.');
      return false;
    }

    return true;
  };
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validateFormData()) {
      try {
        const response = await axios.post(process.env.REACT_APP_API_PATH + '/api/posts/', formData);

        if (response.status === 200) {
          toast.success('Novo texto criado com sucesso!');
          navigate('/');
        } else {
          toast.error('Error: ' + response.data.message);
        }
      } catch (err: any) {
        toast.error('Error: ' + err.message);
      }
    }
  };
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState<boolean | null>(null);
  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    setIsDarkMode(storedTheme === 'dark');
  }, []);

  function Asterisk() {
    return <span className="dark:text-dark-tertiary">*</span>;
  }

  return (loggedUser !== '' ? (
    <div className="min-h-screen cursor-default bg-slate-50 px-6 py-8 dark:bg-dark">
      <div className="mb-4 flex justify-center">
        <div className="flex w-[32rem] items-center justify-start space-x-4 md:w-5/6 lg:w-4/6 ">
          <div className="w-fit cursor-pointer">
            <img
              src={isDarkMode ? navigateBackWhiteIcon : navigateBackBlackIcon}
              alt="Voltar"
              onClick={() => navigate(-1)}
              className="h-5 w-10"
            />
          </div>
          <h2 className="text-lg font-semibold text-light-primary dark:text-dark-primary md:text-xl lg:text-2xl">
            Novo texto
          </h2>
        </div>
      </div>
      <div className="flex justify-center ">
        <form onSubmit={handleSubmit} className="md:w-5/6 lg:w-2/3">
          <div className="mb-2 flex items-center">
            <label className="flex items-center">
              <span className="px-2 text-base font-medium text-light-secondary dark:text-dark-secondary">
                É um destaque?
              </span>
              <input
                type="checkbox"
                name="isFeaturedPost"
                className="ml-2 h-5 w-5 rounded-full accent-purple-400 "
                checked={formData.isFeaturedPost}
                onChange={handleCheckboxChange}
              />
            </label>
          </div>

          <div className="mb-2">
            <div className="px-2 py-1 font-medium text-light-secondary dark:text-dark-secondary">
              Título <Asterisk />
            </div>
            <input
              type="text"
              name="title"
              placeholder="Informe aqui o título do texto"
              autoComplete="off"
              className="w-full rounded-lg bg-slate-200 p-3 placeholder:text-sm placeholder:text-light-tertiary dark:bg-dark-card dark:text-slate-50 dark:placeholder:text-dark-tertiary"
              value={formData.title}
              onChange={handleInputChange}
            />
          </div>

          <div className="mb-1">
            <div className="flex justify-between items-center px-2 py-1">
              <div className="font-medium text-light-secondary dark:text-dark-secondary">
                Conteúdo ({activeTab === 'pt-br' ? 'Português' : 'Inglês'}) <Asterisk />
              </div>
              <div className="flex items-center space-x-2">
                <button
                  type="button"
                  onClick={() => setActiveTab('pt-br')}
                  className={`px-3 py-1 rounded text-xs font-semibold transition-colors ${activeTab === 'pt-br' ? 'bg-light-primary text-light dark:bg-dark-primary dark:text-dark-card' : 'bg-slate-200 dark:bg-dark-card text-light-secondary dark:text-dark-secondary'}`}
                >
                  Português
                </button>
                <button
                  type="button"
                  onClick={() => setActiveTab('en')}
                  className={`px-3 py-1 rounded text-xs font-semibold transition-colors ${activeTab === 'en' ? 'bg-light-primary text-light dark:bg-dark-primary dark:text-dark-card' : 'bg-slate-200 dark:bg-dark-card text-light-secondary dark:text-dark-secondary'}`}
                >
                  Inglês
                </button>
                {activeTab === 'en' && (
                  <button
                    type="button"
                    onClick={handleTranslateContent}
                    disabled={isTranslating}
                    className="px-3 py-1 rounded text-xs font-semibold bg-emerald-600 text-white hover:bg-emerald-700 disabled:bg-emerald-850 transition-colors"
                  >
                    {isTranslating ? 'Traduzindo...' : 'Gerar versão em inglês'}
                  </button>
                )}
              </div>
            </div>
            <MDEditor height={500} 
              value={formData.description[activeTab]} 
              onChange={(value) => handleEditorChange(value || '')} 
              className={style.reactMarkDown} />
          </div>

          <div className="mb-2">
            <div className="px-2 py-1 font-medium text-light-secondary dark:text-dark-secondary">
              Autor <Asterisk />
            </div>
            <input
              type="text"
              name="authorName"
              placeholder="Nome do autor"
              className="w-full rounded-lg bg-slate-200 p-3 placeholder:text-sm placeholder:text-light-tertiary dark:bg-dark-card dark:text-slate-50 dark:placeholder:text-dark-tertiary"
              value={formData.authorName}
              onChange={handleInputChange}
            />
          </div>

          <div className="px-2 py-1 font-medium text-light-secondary dark:text-dark-secondary">
            Foto para a página principal
            <span className="text-xs tracking-wide text-dark-tertiary">
              &nbsp;(jpg/png/webp)&nbsp;
            </span>
            <Asterisk />
          </div>
          <div className="mb-4 flex justify-between gap-2 md:gap-4">
            <input
              type="url"
              id="imagelink"
              name="imageLink"
              placeholder="https://&hellip;"
              autoComplete="off"
              className="w-3/4 rounded-lg bg-slate-200 p-3 placeholder:text-sm placeholder:text-light-tertiary dark:bg-dark-card dark:text-slate-50 dark:placeholder:text-dark-tertiary lg:w-10/12"
              value={formData.imageLink}
              onChange={handleInputChange}
            />
            <button
              type="button"
              className="lg:text-md w-1/4 rounded-lg bg-light-primary text-xs text-slate-50 hover:bg-light-primary/80 dark:bg-dark-primary dark:text-dark-card dark:hover:bg-dark-secondary/80 md:text-sm lg:w-2/12 lg:px-4 lg:py-3"
              onClick={() => {
                setmodal(true);
              }}
            >
              Escolher
            </button>
          </div>
          <div className="mb-4 flex flex-col">
            <label className="px-2 pb-1 font-medium text-light-secondary dark:text-dark-secondary md:mr-4 md:w-fit">
              Categorias
              <span className="text-xs tracking-wide text-dark-tertiary">
                &nbsp;(3 no máximo)&nbsp;
              </span>
              <Asterisk />
            </label>
            <div className="flex flex-wrap gap-3 rounded-lg p-2 dark:bg-dark-card dark:p-3">
              {categories.map((category, index) => (
                <span key={`${category}-${index}`} onClick={() => handleCategoryClick(category)}>
                  <CategoryPill
                    category={category}
                    selected={formData.categories.includes(category)}
                    disabled={isValidCategory(category)}
                  />
                </span>
              ))}
            </div>
          </div>

          <button
            type="submit"
            className="flex w-full items-center justify-center rounded-lg bg-light-primary px-12 py-3 text-base font-semibold text-light hover:bg-light-primary/80 dark:bg-dark-primary dark:text-dark-card dark:hover:bg-dark-secondary/80 md:mx-1 md:w-fit"
          >
            Post blog
          </button>
        </form>
        <ModalComponent
          selectedImage={selectedImage}
          handleImageSelect={handleImageSelect}
          handleSelector={handleselector}
          setModal={setmodal}
          modal={modal}
        />
      </div>
    </div>
  ) : (<></>));
}

export default AddBlog;
